/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.24"
        height="15.71"
        viewBox="0 0 19.24 15.71"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m0 6.77 9.48 8.69.13.25.11-.2 9.52-8.74L15.5 0H3.73Zm1.91.4h3.44l2.88 5.8Zm7.73 6.38L6.47 7.17h6.63Zm1.54-.74 3-5.64h3.09ZM14.91 1l2.85 5.17h-3.49L12.19 1Zm-3.79 0 2.08 5.17H6.36L8.13 1Zm-4 0L5.35 6.17H1.52L4.37 1Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'DiamondIcon';

export default Icon;
